<template>
  <div class="logIn">
    <div class="authorization-category" :class="{ expanded: show }">
      <div class="logIn-category">
        <router-link
          :to="
            $authI18nRoute({
              name: 'LogIn',
            })
          "
          class="logIn-category-btn"
        >
          {{ $t("authorization.enter") }}
          <div class="border"></div>
        </router-link>
      </div>
      <div class="mdborder"></div>
      <div class="logIn-category">
        <router-link
          :to="
            $authI18nRoute({
              name: 'Registration',
            })
          "
          class="logIn-category-btn"
          >{{ $t("authorization.registration") }}
          <div class="border"></div>
        </router-link>
      </div>
    </div>
    <div class="logIn-form">
      <div class="logIn-content">
        <form @submit.prevent="enterToPage()">
          <div class="logIn-input">
            <input
              id="login"
              name="login"
              type="text"
              :placeholder="$t('authorization.login')"
              v-model="login"
              :style="{
                border: show.loginHint
                  ? '1px solid rgba(211, 77, 77, 0.35)'
                  : '',
                background: show.loginHint ? '#F5F0F0' : '',
              }"
              required
            />
            <label for="login" v-if="show.loginHint">{{
              $t("authorization.wronglogin")
            }}</label>
            <label for="login" v-if="!show.loginHint && show.errLog">
              {{ show.errLog }}
            </label>
          </div>
          <div class="password-input">
            <div
              class="password-content"
              :style="{
                border: show.loginHint
                  ? '1px solid rgba(211, 77, 77, 0.35)'
                  : '',
                background: show.loginHint ? '#F5F0F0' : '',
              }"
            >
              <input
                :type="show.password ? 'text' : 'password'"
                id="password"
                name="password"
                :placeholder="$t('authorization.password')"
                v-model="password"
                required
              />
              <div class="password-btn" @click="show.password = !show.password">
                <i class="fas fa-eye-slash" v-if="show.password"></i>
                <i class="fas fa-eye" v-if="!show.password"></i>
              </div>
            </div>
            <label for="password" v-if="show.passwordHint">{{
              $t("authorization.wrongpassword")
            }}</label>
          </div>
          <div class="forgotPassword">
            <router-link
              :to="$authI18nRoute({ name: 'Recovery' })"
              class="forgotPasswordBtn"
            >
              {{ $t("authorization.forogtPassword") }}
            </router-link>
          </div>
          <div class="enter">
            <button class="enterBtn" type="submit">
              {{ $t("authorization.enter") }}
            </button>
          </div>
        </form>
        <router-link
          :to="$i18nRoute({ name: 'FeedWrapper' })"
          class="goBackBtn"
          >{{ $t("authorization.mainPage") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { useStore } from "vuex";
import { useLanguage } from "@/utils/language";
import { useRouter, useRoute } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const { i18n } = useLanguage();
    const login = ref();
    const password = ref();

    const activeLang = ref(route.params.lang);

    console.log(route);
    console.log(activeLang);

    const show = reactive({
      password: false,
      passwordHint: false,
      loginHint: false,
      errLog: false,
    });

    const i18nRoute = (to) => {
      return {
        ...to,
        name: `${i18n.global.locale.value || i18n.global.locale}_${to.name}`,
      };
    };

    const enterToPage = () => {
      show.loginHint = !login.value || login.value.length === 0;
      show.passwordHint = !password.value || password.value.length === 0;

      if (show.passwordHint || show.loginHint) {
        return;
      }

      store.dispatch("getTokens", {
        credentials: {
          username: login.value.trim(),
          password: password.value,
        },

        cb: () => {
          router.push(
            i18nRoute({
              name: "PreferredLang_StaffDetail",
              params: { username: login.value.trim() },
            })
          );
        },

        err: async (err) => {
          if (
            err.detail === "No active account found with the given credentials"
          ) {
            show.loginHint = show.passwordHint = true;
          } else {
            show.errLog = err;
          }
        },
      });
    };

    return {
      login,
      password,
      show,
      enterToPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.logIn {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  font-family: "Roboto", sans-serif;
  width: 40rem;
  min-height: 31.25rem;
  // background-color: white;
  .authorization-category {
    display: flex;
    justify-content: space-around;
    width: 100%;

    .logIn-category {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .logIn-category-btn {
        font-size: 1.875em;
        font-weight: 400;
        line-height: 2.198em;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // margin-top: 1.188rem;
        color: rgba(93, 93, 93, 1);
        background: transparent;
        outline: none;
        cursor: pointer;

        &:hover,
        &.router-link-exact-active {
          .border {
            background: rgba(29, 82, 149, 1);
            height: 0.313rem;
            transition: all 0.5s;
          }
        }
      }
    }
    .border {
      width: 100%;
      height: 1px;
      background: rgba(230, 230, 230, 1);
      // margin-top: 1.125rem;
    }
    .mdborder {
      width: 1px;
      height: 2.625rem;
      background: #e6e6e6;
      margin-top: 0.938rem;
    }
  }
  .logIn-form {
    .logIn-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 3.438rem;
      padding-bottom: 1rem;
      width: 21rem;

      form {
        margin: auto;
        .logIn-input {
          display: flex;
          flex-direction: column;
          input {
            width: 20.938rem;
            height: 3.375rem;
            font-size: 1em;
            line-height: 1.172em;
            font-weight: 300;
            outline: none;
            bottom: none;
            background: rgba(0, 0, 0, 0.03);
            padding: 0 20px;
            font-family: "Roboto", sans-serif;
          }
          label {
            color: #d34d4d;
            margin-top: 5px;
            font-family: "Roboto", sans-serif;
          }
          &::placeholder {
            font-family: "Roboto", sans-serif;
          }
        }
        .password-input {
          display: flex;
          flex-direction: column;
          .password-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 1.313rem;
            width: 20.938rem;
            height: 3.375rem;
            background: rgba(0, 0, 0, 0.03);
            input {
              font-size: 1em;
              line-height: 1.172em;
              font-weight: 300;
              outline: none;
              bottom: none;
              background: transparent;
              width: 80%;
              height: 100%;
              padding-left: 1.25rem;
              font-family: "Roboto", sans-serif;
            }
            .password-btn {
              display: flex;
              i {
                color: #808080;
                width: 1.875rem;
                height: 1.875rem;
                display: flex;
                align-items: center;
                cursor: pointer;
              }
            }
            &::placeholder {
              font-family: "Roboto", sans-serif;
            }
          }
          label {
            color: #d34d4d;
            margin-top: 5px;
          }
        }
        .forgotPassword {
          display: flex;
          justify-content: flex-end;
          .forgotPasswordBtn {
            font-size: 0.938em;
            line-height: 1.099em;
            margin-top: 0.313rem;
            margin-bottom: 1.375rem;
            background-color: transparent;
            color: rgba(166, 181, 199, 1);
            cursor: pointer;
          }
        }
        .enter {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .enterBtn {
            width: 21.563rem;
            height: 4.375rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 1.563rem;
            font-size: 1.75em;
            line-height: 2.051em;
            font-weight: 500;
            color: #fff;
            background: rgba(29, 82, 149, 1);
            cursor: pointer;
          }
        }
      }

      .goBackBtn {
        background: transparent;
        font-size: 1.125em;
        line-height: 1.318em;
        font-weight: 300;
        color: rgba(128, 128, 128, 1);
        border-bottom: 1px solid rgba(128, 128, 128, 1);
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .logIn {
    width: 33rem;
    min-height: 26.875rem;
    .authorization-category {
      width: 100%;
      .logIn-category {
        .logIn-category-btn {
          font-size: 1.625em;
          line-height: 1.904em;
          font-weight: 400;
          color: rgba(93, 93, 93, 1);
          width: 100%;
        }
      }
      .mdborder {
        width: 1px;
        height: 2.188rem;
        margin-top: 0.438rem;
      }
    }
    .logIn-form {
      .logIn-content {
        width: 21rem;
        margin-top: 2.813rem;

        form {
          margin: auto;
        }
      }
    }
  }
}
@media screen and (max-width: 540px) {
  .logIn {
    width: 20.938rem;
    min-height: 23.188rem;
    .authorization-category {
      width: 100%;
      .logIn-category {
        .logIn-category-btn {
          font-size: 1.2em;
          line-height: 1.758em;
          font-weight: 400;
          color: rgba(93, 93, 93, 1);
          width: 100%;
        }
      }
      .mdborder {
        width: 1px;
        height: 2.188rem;
        margin-top: 0.313rem;
      }
    }
    .logIn-form {
      .logIn-content {
        margin-top: 2.813rem;

        form {
          margin: auto;
          .logIn-input {
            input {
              width: 15.438rem;
              height: 2.813rem;
            }
            label {
              margin-top: 0.188rem;
            }
          }
          .password-input {
            .password-content {
              width: 15.438rem;
              height: 2.813rem;
              input {
                width: 15.438rem;
                height: 2.813rem;
              }
            }
          }
          .enter {
            .enterBtn {
              width: 15.875rem;
              height: 3.75rem;
            }
          }
        }
        .goBackBtn {
          font-size: 1.125em {
            line-height: 1.318em;
            font-weight: 300;
          }
        }
      }
    }
  }
}
</style>
